import classes from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage.module.less";
import { Trans, useTranslation } from "react-i18next";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";
import { type ResultsHeaterProps } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage";
import { Link } from "~/common/components/Link";
import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";
import { resolveUrl } from "~/utils/url/urlResolver";
import { Button } from "~/common/mui";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { usePurchasePlace, usePurchaseType } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import { appendPurchaseParams } from "~/features/productDetails/components/ProductSummary/PdpSummaryHelper";

interface TableProps {
  data: ResultsHeaterProps[];
}

export function ResultHS({ data }: TableProps) {
  const { t } = useTranslation();
  const isMinTablet = useIsMinTabletSize();

  const purchase_place = usePurchasePlace();
  const purchase_type = usePurchaseType();

  const linkElement = (item: ResultsHeaterProps) => {
    const href = appendPurchaseParams(item.url, purchase_place, purchase_type);
    return (
      <Link className={classes.resultListItemLink} href={href} iconBefore={<Icon type={IconType.ChevronRight} />}>
        {t("heaterSelectionAssistant.result.item.link", { name: item.name })}
      </Link>
    );
  };

  if (data.length > 0) {
    return (
      <>
        <div className={classes.resultTitle}>{t("heaterSelectionAssistant.results.title")}</div>
        <div className={classes.resultList}>
          {data.map((item, index) => (
            <div key={index} className={classes.resultListItem}>
              {index === 0 && (
                <div className={classes.resultListItemBanner}>
                  {t("heaterSelectionAssistant.result.item.optimal.label")}
                </div>
              )}
              <div className={classes.resultListItemRow}>
                <img src={item.imageUrl} className={classes.resultListItemImage} />
                <div className={classes.resultListItemContent}>
                  <div className={classes.resultListItemName}>{item.name}</div>
                  <div className={classes.resultListItemDescription}>
                    <Trans i18nKey={"heaterSelectionAssistant.result.item.description"}>
                      SMART/BASIC HEATER suitable for bearings up to <span>{{ mass: item.mass }}</span> kg
                    </Trans>
                  </div>
                  {isMinTablet && <>{linkElement(item)}</>}
                </div>
              </div>
              {!isMinTablet && <>{linkElement(item)}</>}
            </div>
          ))}
        </div>
      </>
    );
  } else {
    return (
      <div className={classes.emptyStateSection}>
        <div className={classes.emptyStateTitle}>{t("heaterSelectionAssistant.emptyState.title")}</div>
        <img
          className={classes.emptyStateImage}
          src={"https://cdn.schaeffler-ecommerce.com/cdn/illustrationEmptyHeaterSelectionAssistant.png"}
        />
        <div className={classes.emptyStateDescription}>{t("heaterSelectionAssistant.emptyState.description")}</div>
        <ol className={classes.emptyStateList}>
          <li>{t("heaterSelectionAssistant.emptyState.stepOne")}</li>
          <li>
            <Trans i18nKey={"heaterSelectionAssistant.emptyState.stepTwo"}>
              {""}
              <a href={resolveUrl("/mount/induction-units-with-medium-frequency-technology")} target="_blank">
                Explore
              </a>{" "}
              alternative ways of mounting and dismounting bearings.
            </Trans>
          </li>
        </ol>
        <Button className={classes.emptyStateButton} href={URL_CONTACT_US}>
          {t("heaterSelectionAssistant.emptyState.button")}
        </Button>
      </div>
    );
  }
}
